/**
 * TITA 平台配置（非 EB Basics）
 * 菜单 route 建议：/platform/config（需在 ti_eb_system_menu 增加侧栏项）
 */
import Layout from '@/layout/index.vue';
import type { RouteRecordRaw } from 'vue-router';
import { roterPre } from '@/setting';

const platformRouter: RouteRecordRaw = {
  path: `${roterPre}/platform`,
  name: 'TitaPlatform',
  component: Layout,
  alwaysShow: true,
  meta: {
    title: 'TITA平台',
    icon: 'setting',
  },
  children: [
    {
      path: 'config',
      name: 'TitaPlatformConfig',
      meta: {
        title: '平台配置',
        noCache: true,
      },
      component: () => import('@/views/_expand/platform-config/index.vue'),
    },
  ],
};

export default platformRouter;
